<script setup lang="ts">
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.33398 4.66699H10.8922C11.0552 4.66699 11.1367 4.66699 11.2135 4.68541C11.2815 4.70174 11.3465 4.72868 11.4062 4.76523C11.4735 4.80646 11.5311 4.86411 11.6464 4.97941L14.3549 7.68791C14.4702 7.80321 14.5278 7.86086 14.5691 7.92814C14.6056 7.98778 14.6326 8.05281 14.6489 8.12084C14.6673 8.19756 14.6673 8.27909 14.6673 8.44215V10.3337C14.6673 10.6443 14.6673 10.7996 14.6166 10.9221C14.5489 11.0855 14.4191 11.2152 14.2558 11.2829C14.1333 11.3337 13.9779 11.3337 13.6673 11.3337M10.334 11.3337H9.33398M9.33398 11.3337V4.80033C9.33398 4.05359 9.33398 3.68022 9.18866 3.395C9.06083 3.14412 8.85685 2.94015 8.60597 2.81232C8.32076 2.66699 7.94739 2.66699 7.20065 2.66699H3.46732C2.72058 2.66699 2.34721 2.66699 2.062 2.81232C1.81111 2.94015 1.60714 3.14412 1.47931 3.395C1.33398 3.68022 1.33398 4.05359 1.33398 4.80033V10.0003C1.33398 10.7367 1.93094 11.3337 2.66732 11.3337M9.33398 11.3337H6.66732M6.66732 11.3337C6.66732 12.4382 5.77189 13.3337 4.66732 13.3337C3.56275 13.3337 2.66732 12.4382 2.66732 11.3337M6.66732 11.3337C6.66732 10.2291 5.77189 9.33366 4.66732 9.33366C3.56275 9.33366 2.66732 10.2291 2.66732 11.3337M13.6673 11.667C13.6673 12.5875 12.9211 13.3337 12.0007 13.3337C11.0802 13.3337 10.334 12.5875 10.334 11.667C10.334 10.7465 11.0802 10.0003 12.0007 10.0003C12.9211 10.0003 13.6673 10.7465 13.6673 11.667Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
